import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function EmployeeVerifyPage() {
  const { employeeId } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(`${API}/public/employee-card/${employeeId}`);
        if (!res.ok) { setError('لم يتم العثور على بيانات هذه البطاقة'); }
        else setData(await res.json());
      } catch { setError('تعذر الاتصال بالخادم'); }
      setLoading(false);
    })();
  }, [employeeId]);

  const logoUrl = data?.club_logo_file_id ? `${API}/files/${data.club_logo_file_id}` : null;

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#060f1c] p-4" dir="rtl" data-testid="employee-verify-page">
      <div className="w-full max-w-sm rounded-2xl border border-teal-900/30 bg-[#0A192F] p-6 text-center shadow-2xl">
        {loading ? (
          <div className="py-10 text-sm text-slate-400" data-testid="employee-verify-loading">جارٍ التحقق...</div>
        ) : error ? (
          <div className="py-10" data-testid="employee-verify-error">
            <div className="mx-auto mb-3 flex h-14 w-14 items-center justify-center rounded-full bg-red-500/10 text-2xl text-red-400">؟</div>
            <p className="text-sm font-semibold text-red-400">{error}</p>
          </div>
        ) : (
          <div data-testid="employee-verify-result">
            <div className="flex flex-col items-center gap-2 border-b border-white/10 pb-4">
              {logoUrl ? (
                <img src={logoUrl} alt="شعار المنشأة" className="h-14 w-14 rounded-xl object-contain" />
              ) : (
                <div className="flex h-14 w-14 items-center justify-center rounded-xl bg-teal-500/10 text-lg font-black text-teal-400">؟</div>
              )}
              <div className="text-sm font-bold text-white" data-testid="employee-verify-club-name">{data?.club_name || 'منشأة رياضية'}</div>
            </div>

            <div className="mt-4">
              <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-teal-500/10 text-2xl font-black text-teal-400">
                {data?.full_name?.trim().charAt(0) || '؟'}
              </div>
              <div className="mt-3 text-lg font-bold text-white" data-testid="employee-verify-name">{data?.full_name}</div>
              <div className="text-sm text-slate-300">{data?.position}</div>
              {data?.department && <div className="text-xs text-slate-500">{data.department}</div>}
            </div>

            <div className="mt-5 flex items-center justify-center gap-2">
              <span
                className={`rounded-full px-4 py-1.5 text-xs font-bold ${data?.is_active ? 'bg-teal-500/10 text-teal-400' : 'bg-red-500/10 text-red-400'}`}
                data-testid="employee-verify-status"
              >
                {data?.is_active ? 'منسوب فعلياً لهذه المنشأة' : 'غير نشط حالياً'}
              </span>
            </div>

            {data?.employee_number && (
              <div className="mt-4 border-t border-white/10 pt-3 text-xs text-slate-500" dir="ltr" data-testid="employee-verify-number">
                {data.employee_number}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
